import React, { useState, useEffect } from "react";
import "./App.css";

const WeatherApp = () => {
  const [weather, setWeather] = useState({});
  const [city, setCity] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      if (city !== "") {
        const response = await fetch(
          `https://pythoncodenemesis.pythonanywhere.com/weather?city=${city}`
        );
        const data = await response.json();
        setWeather(data);
      }
    };
    fetchData();
  }, [city]);

  return (
    <div className="weather-container">
      <h2 className="header">Weather App</h2>
      <div className="search-container">
        <input
          type="text"
          value={city}
          onChange={(e) => setCity(e.target.value)}
          placeholder="Enter city name"
        />
        <button onClick={() => setCity(city)}>Search</button>
      </div>
      {weather.main && (
        <div className="weather-details">
          <p className="city-name">{weather.name}</p>
          <p className="weather-main">{weather.weather[0].main}</p>
          <p className="temperature">
            Temperature: {Math.round(weather.main.temp - 273.15)}°C
          </p>
          <div className="map-container">
            <p>Map Location:</p>
            <iframe
              width="400"
              height="300"
              frameBorder="0"
              scrolling="no"
              marginHeight="0"
              marginWidth="0"
              src={`https://www.openstreetmap.org/export/embed.html?bbox=${weather.coord.lon}%2C${weather.coord.lat}%2C${weather.coord.lon}%2C${weather.coord.lat}&layer=mapnik`}
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default WeatherApp;
